import { useEffect, useState } from 'react';
import { usersService, IUserOption } from '../services/usersService';

let cachedUsers: IUserOption[] | null = null;
let loadingPromise: Promise<IUserOption[]> | null = null;

export function useUsers() {
  const [users, setUsers] = useState<IUserOption[]>(cachedUsers || []);
  const [loading, setLoading] = useState(!cachedUsers);

  useEffect(() => {
    if (cachedUsers) {
      setUsers(cachedUsers);
      setLoading(false);
      return;
    }

    if (!loadingPromise) {
      loadingPromise = usersService
        .list()
        .then(data => {
          cachedUsers = data;
          return data;
        })
        .catch(err => {
          loadingPromise = null;
          throw err;
        });
    }

    loadingPromise
      .then(data => {
        setUsers(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erro ao carregar usuários:', err);
        setLoading(false);
      });
  }, []);

  const getUserName = (id: string): string => {
    const user = users.find(u => u.id === id);
    return user?.name || id;
  };

  return { users, loading, getUserName };
}
